import {gql} from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const GET_CLUBS = gql`
  query getClubs {
    getClubs {
      _id
      name
      address {
        country
        state
        city
      }
    }
  }
`;
